
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  pageNotFoundMessage: {
    id: "PageNotFound.message",
    defaultMessage: "Sorry, we didn't found the page you are looking for.",
  },
});

export default MESSAGES;